import React, { Fragment, useContext, useEffect, useState } from 'react';
import './GuidancePageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import GlobalContext from "root/Contexts/GlobalContext";
import { getProviderAuthorisedSurveyList } from "root/DataFunctions/ProviderFns";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getActiveGuidanceForSurveyType } from "root/DataFunctions/GuidanceFunctions";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";


const GuidancePageBody = (props) =>
{

    useEffect(()=>{
        getData();
    },[])

    const [data, setData] = useState({isLoading: true, data: []});

    const sessionContext = useContext( GlobalContext ) ;

    const survey_type = sessionContext.getCurrentSurveyType() ;

    const getData = () => {

        getActiveGuidanceForSurveyType(survey_type, (response) =>
        {
            const responseData = getDataFromResponse(response);

            setData({isLoading: false, data: responseData});
        });
    };

    const guidancePage = () =>
    {
        return (
            <div>
                {data.data.map((row, key) =>
                    <div key={key} className='guidance-section'>{ row.title }
                        <p><a target='_blank' href={ row.url }>{ row.hyperlink_text }</a></p>
                    </div>
                )}
            </div>
        )
    }

    const guidance = () =>
    {
        if ( data.isLoading === true )
        {
            return <SpinnerDiv/>
        }
        else
        {
            return guidancePage() ;
        }
    }

    return (
        <Fragment>
            <PageBodyWrapper title='Guidance Notes' backButton={false}>
                <div className='guidance-layout'>
                    <div className='table-section-rows'>
                        <h5>Links you may find useful when completing your audit</h5>
                    </div>
                    {guidance()}
                </div>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default GuidancePageBody;
